<template>
  <v-container id="vehicledriver" fluid tag="section">
    <v-row justify="center" class="mx-10">
      <v-col cols="12" md="4">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Vehicle") }}</h2>
          </div>
          <router-link :to="'/vehicles'">
            <h4>
              <i class="icon-real-estate-045"></i>
              {{ $i18n.t("Vehicles") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Driver") }}</h2>
          </div>
          <router-link :to="'/drivers'">
            <h4>
              <i class="icon-finance-174"></i>
              {{ $i18n.t("Drivers") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Settings") }}</h2>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VehicleDriver",

  data() {
    return {};
  },

  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>


<style scoped>
a {
  text-decoration: none;
}
</style>